import { Card, CardContent, Grid, TextField, Typography, Button, useMediaQuery, useTheme, RadioGroup, FormControlLabel, Radio, Autocomplete, Box, IconButton, CircularProgress, lighten } from '@mui/material';
import { useState, Fragment, useEffect } from 'react';
import Styles from '../../../theme/commonCss/Styles';
import Ajv from 'ajv';
import Modal from '../../../common/Modal';
import { cloneDeep, get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { ReactComponent as SaveIcon } from '../../../assets/icons/main/save-icon.svg';
import { ReactComponent as CreateIcon } from '../../../assets/icons/main/create-icon.svg';
import RadioComponent from '../../../components/Radio';
import CheckboxComponent from '../../../components/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SelectComponent from '../../../components/Select';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { styled } from '@mui/material';
import { useDispatch } from 'react-redux';
import { machineryManagementActions } from '../../../store/reducers/machinery-management';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import AjvErrors from 'ajv-errors';
import { customDaysSchema, dailySchema, maintenanceSchema, monthlySchema, monthlySchemaCustomDays, monthlySchemaEveryMonth, severitySchema, weeklySchema, yearlySchema, yearlySchemaCustomMonth, yearlySchemaCustomSelected } from './formSchema';
import { ReactComponent as CloseIcon } from '../../../assets/icons/main/close-icon.svg';
import AddEditActivity from '../ActivityList/addEditActivity';
import { maintenanceManagementActions } from '../../../store/reducers/maintenance-management';
import PopUp from '../../../components/Popup';
import TimePickerComponent from '../components/TimePickerComponent';
import OntologySelector from '../../../common/OntologySelector';
import { getCurrentTime } from '../../../utils/time-converter';
import { pageActions } from '../../../store/reducers/page-actions';
import { palette } from '../../../theme/palette';
import { ReactComponent as SuccessIcon } from '../../../assets/icons/main/successIcon.svg';
import { ReactComponent as DownwardIcon } from '../../../assets/icons/main/chevron-down-icon.svg';
import lightOrdarkColor from '@check-light-or-dark/color';

const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

const severityList: any = [
  {
    label: 'High',
    value: 1,
  },
  {
    label: 'Medium',
    value: 2
  },
  {
    label: 'Low',
    value: 3,
  },
];

const DailyComponent = ({ data, disabled, ajvErrors, onChangeValues }: any) => {
  return (
    <RadioGroup
      row
      aria-labelledby='demo-row-radio-buttons-group-label'
      name='row-radio-buttons-group'
      sx={{ marginTop: '6px', display: 'flex', flexDirection: 'column' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <RadioComponent
          name='daily_value'
          value='custom_days'
          onChange={(e: any) => onChangeValues('daily_value', e.target.value)}
          checked={data.daily_value === 'custom_days'}
          disabled={disabled}
          sx={{
            ml: '-8px',
          }}
        />{' '}
        <Typography
          sx={{
            ...Styles.inputLabel,
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '10px',
            alignItems: 'center',
          }}
        >
          Every{' '}
          <TextField
            type='text'
            disabled={data.daily_value === 'every_weekday' || disabled}
            name='recurs_every'
            value={data.recurs_every}
            onChange={(e) => onChangeValues('recurs_every', e.target.value)}
            variant='outlined'
            sx={{ width: '84px' }}
            error={ajvErrors.instancePath && ajvErrors.instancePath.includes('recurs_every')}
          />{' '}
          day(s)
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <RadioComponent
          name='daily_value'
          value='every_weekday'
          onChange={(e: any) => onChangeValues('daily_value', e.target.value)}
          checked={data.daily_value === 'every_weekday'}
          disabled={disabled}
          sx={{
            ml: '-8px',
          }}
        />{' '}
        <Typography
          sx={{
            ...Styles.inputLabel,
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '10px',
            alignItems: 'center',
          }}
        >
          Every weekday
        </Typography>
      </Box>
    </RadioGroup>
  );
}

const WeeklyComponent = ({ data, disabled, ajvErrors, onChangeValues }: any) => {
  const themeData: any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  const weekdaysList: any = [
    {
      id: 1,
      label: 'S',
      value: 'Sunday'
    },
    {
      id: 1,
      label: 'M',
      value: 'Monday'
    },
    {
      id: 1,
      label: 'T',
      value: 'Tuesday'
    },
    {
      id: 1,
      label: 'W',
      value: 'Wednesday'
    },
    {
      id: 1,
      label: 'T',
      value: 'Thursday'
    },
    {
      id: 1,
      label: 'F',
      value: 'Friday'
    },
    {
      id: 1,
      label: 'S',
      value: 'Saturday'
    }
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography
        sx={{
          ...Styles.inputLabel,
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px',
          alignItems: 'center',
        }}
      >
        Every
        <TextField
          name='recurs_every'
          onChange={(e) => onChangeValues('recurs_every', e.target.value)}
          disabled={disabled}
          variant='outlined'
          sx={{ width: '84px' }}
          value={data.recurs_every}
          error={ajvErrors.instancePath && ajvErrors.instancePath.includes('recurs_every')}
        />
        weeks(s) on
      </Typography>
      <Box sx={{ display: 'flex', gap: '16px', marginTop: '13px' }}>
        {weekdaysList.map((item: any) => (
          <Box
            onClick={() => {
              if (!disabled) {
                onChangeValues('recurs_days', item.value);
              }
            }}
            style={{
              display: 'flex',
              cursor: 'pointer',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              width: '32px',
              height: '32px',
              borderRadius: '23px',
              backgroundColor: data.recurs_days.includes(item.value) ? themeData.palette.primary.main :  lighten(themeData.palette.primary.main, 0.8),
              color: data.recurs_days.includes(item.value) ? palette.primary.contrastText : themeData.palette.text.primary,
              fontSize: '16px',
            }}
          >
            <div>{item.label}</div>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

const MonthlyComponent = ({ data, disabled, ajvErrors, onChangeValues }: any) => {
  return (
    <RadioGroup
      row
      aria-labelledby='demo-row-radio-buttons-group-label'
      name='row-radio-buttons-group'
      sx={{ marginTop: '8px', display: 'flex', flexDirection: 'column' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <RadioComponent
          name='monthly_value'
          value='custom_days'
          onChange={() => onChangeValues('monthly_value', 'custom_days')}
          checked={data.monthly_value === 'custom_days'}
          disabled={disabled}
          sx={{
            ml: '-8px',
          }}
        />{' '}
        <Typography
          sx={{
            ...Styles.inputLabel,
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '10px',
            alignItems: 'center',
          }}
        >
          Day{' '}
          <TextField
            name='day_of_month'
            onChange={(e: any) => onChangeValues('day_of_month', e.target.value)}
            value={data.day_of_month}
            disabled={data.monthly_value === 'every_month' || disabled}
            variant='outlined'
            sx={{ width: '84px' }}
            error={ajvErrors.instancePath && ajvErrors.instancePath.includes('day_of_month')}
          />{' '}
          of every{' '}
          <TextField
            name='recurs_every'
            value={data.monthly_value === 'custom_days' ? data.recurs_every : ''}
            onChange={(e: any) => onChangeValues('recurs_every', e.target.value)}
            disabled={data.monthly_value === 'every_month' || disabled}
            variant='outlined'
            sx={{ width: '84px' }}
            error={ajvErrors.instancePath && ajvErrors.instancePath.includes('recurs_every')}
          />{' '}
          month(s)
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
        <RadioComponent
          name='monthly_value'
          value='every_month'
          onChange={() => onChangeValues('monthly_value', 'every_month')}
          checked={data.monthly_value === 'every_month'}
          disabled={disabled}
          sx={{ mt: 1, ml: '-8px' }}
        />
        <Typography
          sx={{
            ...Styles.inputLabel,
            marginTop: '8px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: '10px',
            alignItems: 'flex-start',
          }}
        >
          <Box display={'flex'} alignItems={'center'} width={'100%'} gap={'10px'}>
            The{' '}
            <SelectComponent
              value={data.nth_week}
              options={[
                { label: 'First', value: 1 },
                { label: 'Second', value: 2 },
                { label: 'Third', value: 3 },
                { label: 'Fourth', value: 4 },
              ]}
              onChange={(e: any) => {
                onChangeValues('nth_week', e.target.value);
              }}
              disabled={data.monthly_value === 'custom_days' || disabled}
              name='nth_week'
              error={ajvErrors.instancePath && ajvErrors.instancePath.includes('nth_week')}
              sx={{
                width: '160px',
              }}
            />{' '}
            <SelectComponent
              value={data.recurs_days}
              options={[
                { label: 'Sunday', value: 'sunday' },
                { label: 'Monday', value: 'monday' },
                { label: 'Tuesday', value: 'tuesday' },
                { label: 'Wednesday', value: 'wednesday' },
                { label: 'Thursday', value: 'thursday' },
                { label: 'Friday', value: 'friday' },
                { label: 'Saturday', value: 'saturday' },
              ]}
              onChange={(e: any) => {
                onChangeValues('recurs_days', e.target.value);
              }}
              disabled={data.monthly_value === 'custom_days' || disabled}
              name='recurs_days'
              error={ajvErrors.instancePath && ajvErrors.instancePath.includes('recurs_days')}
              sx={{
                width: '160px',
              }}
            />
          </Box>
          <Box display={'flex'} alignItems={'center'} gap={'10px'} sx={{ ml: '38px' }}>
            of every{' '}
            <TextField
              name='recurs_every'
              value={data.monthly_value === 'every_month' ? data.recurs_every : ''}
              onChange={(e: any) => onChangeValues('recurs_every', e.target.value)}
              disabled={data.monthly_value === 'custom_days' || disabled}
              variant='outlined'
              sx={{ width: '84px' }}
              error={ajvErrors.instancePath && ajvErrors.instancePath.includes('recurs_every')}
            />
            month(s)
          </Box>
        </Typography>
      </Box>
    </RadioGroup>
  );
}

const YearlyComponent = ({ data, ajvErrors, onChangeValues, disabled }: any) => {
  const MONTHS = [
    { label: 'Jan', value: 1 },
    { label: 'Feb', value: 2 },
    { label: 'Mar', value: 3 },
    { label: 'Apr', value: 4 },
    { label: 'May', value: 5 },
    { label: 'Jun', value: 6 },
    { label: 'Jul', value: 7 },
    { label: 'Aug', value: 8 },
    { label: 'Sep', value: 9 },
    { label: 'Oct', value: 10 },
    { label: 'Nov', value: 11 },
    { label: 'Dec', value: 12 },
  ];

  const DAYS = [
    {
      label: 'Sunday',
      value: 'sunday',
    },
    {
      label: 'Monday',
      value: 'monday',
    },
    {
      label: 'Tuesday',
      value: 'tuesday',
    },
    {
      label: 'Wednesday',
      value: 'wednesday',
    },
    {
      label: 'Thursday',
      value: 'thursday',
    },
    {
      label: 'Friday',
      value: 'friday',
    },
    {
      label: 'Saturday',
      value: 'saturday',
    },
  ];

  return (
    <RadioGroup
      row
      aria-labelledby='demo-row-radio-buttons-group-label'
      name='row-radio-buttons-group'
      sx={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '10px' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Typography
          sx={{
            ...Styles.inputLabel,
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '10px',
            alignItems: 'center',
          }}
        >
          Every{' '}
          <TextField
            name='recurs_every'
            value={data.recurs_every}
            onChange={(e: any) => onChangeValues('recurs_every', e.target.value)}
            disabled={disabled}
            variant='outlined'
            sx={{ width: '84px' }}
            error={ajvErrors.instancePath && ajvErrors.instancePath.includes('recurs_every')}
          />{' '}
          year(s)
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <RadioComponent
          name='yearly_value'
          value='custom_month'
          onChange={(e: any) => onChangeValues('yearly_value', 'custom_month')}
          checked={data.yearly_value === 'custom_month'}
          disabled={disabled}
          sx={{
            ml: '-8px',
          }}
        />{' '}
        <Typography
          sx={{
            ...Styles.inputLabel,
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '10px',
            alignItems: 'center',
          }}
        >
          <Typography sx={{ ...Styles.inputLabel, mr: '30px' }}>on</Typography>
          <SelectComponent
            value={data.yearly_value === 'custom_month' ? data.month : null}
            options={MONTHS}
            onChange={(e: any) => {
              onChangeValues('month', e.target.value);
            }}
            disabled={data.yearly_value === 'every_selected_month' || disabled}
            name='day_on'
            error={
              data.yearly_value === 'custom_month' &&
              ajvErrors.instancePath &&
              ajvErrors.instancePath.includes('/month')
            }
            sx={{
              width: '160px',
            }}
          />{' '}
          <TextField
            name='every'
            value={data.day_of_month}
            onChange={(e: any) => onChangeValues('day_of_month', e.target.value)}
            disabled={data.yearly_value === 'every_selected_month' || disabled}
            variant='outlined'
            sx={{ width: '84px' }}
            error={ajvErrors.instancePath && ajvErrors.instancePath.includes('/day_of_month')}
          />
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
        <RadioComponent
          name='yearly_value'
          value='every_selected_month'
          onChange={(e: any) => onChangeValues('yearly_value', 'every_selected_month')}
          checked={data.yearly_value === 'every_selected_month'}
          disabled={disabled}
          sx={{
            ml: '-8px',
          }}
        />
        <Typography
          sx={{
            ...Styles.inputLabel,
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            justifyContent: 'flex-start',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {' '}
            On the{' '}
            <SelectComponent
              value={data.nth_week}
              options={[
                { label: 'First', value: 1 },
                { label: 'Second', value: 2 },
                { label: 'Third', value: 3 },
                { label: 'Fourth', value: 4 },
              ]}
              onChange={(e: any) => {
                onChangeValues('nth_week', e.target.value);
              }}
              disabled={data.yearly_value === 'custom_month' || disabled}
              name='nth_week'
              error={ajvErrors.instancePath && ajvErrors.instancePath.includes('nth_week')}
              sx={{
                width: '160px',
              }}
            />{' '}
            <SelectComponent
              value={data.recurs_days}
              options={DAYS}
              onChange={(e: any) => {
                onChangeValues('recurs_days', e.target.value);
              }}
              disabled={data.yearly_value === 'custom_month' || disabled}
              name='recurs_days'
              error={ajvErrors.instancePath && ajvErrors.instancePath.includes('recurs_days')}
              sx={{
                width: '160px',
              }}
            />{' '}
            of{' '}
          </Box>
          <Box sx={{ ml: '61px' }}>
            <SelectComponent
              value={data.yearly_value === 'every_selected_month' ? data.month : null}
              options={MONTHS}
              onChange={(e: any) => {
                onChangeValues('month', e.target.value);
              }}
              disabled={data.yearly_value === 'custom_month' || disabled}
              name='month'
              error={
                data.yearly_value === 'every_selected_month' &&
                ajvErrors.instancePath &&
                ajvErrors.instancePath.includes('month')
              }
              sx={{
                width: '160px',
              }}
            />
          </Box>
        </Typography>
      </Box>
    </RadioGroup>
  );
}

const RequiredFieldStar = () => {
  return <Typography component='span' sx={{ fontWeight: 400, fontSize: 16, color: 'red' }}>*</Typography>;
}

const defFormFields: any = {
  onto_manage_id: 0,
  maintenance_type: 'preventive',
  maintenance_name: '',
  machines: [],
  frequency: 'daily',
  recurs_on: {
    daily_value: '',
    recurs_every: '',
    recurs_days: [],
    nth_week: null,
    day_of_month: null,
    month: null,
    monthly_value: '',
    yearly_value: '',
  },
  start_date: dayjs(),
  end_date: dayjs(),
  is_no_end_date: false,
  maintenance_time: getCurrentTime(),
  reference_doc: [],
  description: '',
  severity: 1,
};

const CreateMaintenance = ({
  ontologyData,
  machineryManagementData,
  activities,
  addMaintenancePlanLoading,
  addMaintenancePlanSuccess,
  maintenancePlanLoading,
  maintenancePlan,
  updateMaintenancePlanLoading,
  updateMaintenancePlanSuccess,
  checkMachinePlanData,
  isOntoManagesLoading
}: any) => {
  const theme = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const customStyles = {
    radiolabel: { "&.MuiFormControlLabel-root .MuiFormControlLabel-label": { fontSize: '1rem', fontWeight: '400', color: theme.palette.text.primary } },
    inputContainer: { paddingRight: '24px', paddingLeft: '24px', display: 'flex', flexDirection: 'column', gap: '24px', borderRight: `1px solid ${theme.palette.customBorderColor.main}` }
  }
  const dispatch = useDispatch();
  const ajv = new Ajv({ allErrors: true });
  AjvErrors(ajv);
  const [ajvErrors, setAjvErrors] = useState<any>({});
  const [formData, setFormData] = useState<any>(defFormFields);
  const planId = get(params, 'planId', '');
  const readOnly = location.pathname.includes('view');
  const isEdit = location.pathname.includes('edit');

  const [checklistModal, setChecklistModal] = useState<{ open: boolean, checklistId: number | null }>({ open: false, checklistId: null })
  const [popupStatus, setPopupStatus] = useState({ open: false, message: '' });
  const [resetOntology, setResetOntology] = useState(true);
  const tabView = useMediaQuery('(max-width:900px)');
  const mdScreenView = useMediaQuery('(max-width:1200px)');

  useEffect(() => {
    if (location) {
      let selectedPath: any = '';
      let breadCrumbsName: any = '';
      if (location.state) {
        selectedPath = location.state ? location.state.from ? location.state.from : '' : '';
        breadCrumbsName = location.state ? location.state.breadCrumbsName ? location.state.breadCrumbsName : '' : '';
        setFormData({ ...formData, maintenance_type: get(location, 'state.tab', 'preventive') });
      }
      if (location.pathname.length) {
        const pathnamesTemp: any = location.pathname.split('/').filter(Boolean);
        if (pathnamesTemp.length) {
          const pathnamesData: any = pathnamesTemp
            .filter((i: any, index: number) => index != 3)
            .map((item: any, index: number) => {
              if (index == 0) {
                return { route: pathnamesTemp[0], pathName: 'Maintenance Management', navigate: true };
              } else if (index == 1) {
                const machineListPathname = selectedPath === 'machine-list' ? 'Machine Maintenance Status' : selectedPath.replace('-', ' ')
                return { route: selectedPath != '' ? pathnamesTemp[0] + '/' + selectedPath : pathnamesTemp[0] + '/' + pathnamesTemp[1], pathName: breadCrumbsName != '' ? breadCrumbsName : selectedPath != '' ? machineListPathname : 'Maintenance Plans', navigate: true };
              } else {
                return { route: '', pathName: readOnly ? 'View Plan' : isEdit ? 'Edit Plan' : 'Create Plan', navigate: false };
              }
            });
          dispatch(pageActions.setPagePath(pathnamesData));
          return () => {
            const data: any = [];
            dispatch(pageActions.setPagePath(data));
          };
        }
      }
    }
  }, [location])


  useEffect(() => {
    dispatch(maintenanceManagementActions.getActivityListRequest({}));
    dispatch(machineryManagementActions.getMachineryManagementDataRequest())

    return () => {
      dispatch(maintenanceManagementActions.resetMaintenancePlanState());
    };
  }, [])

  useEffect(() => {
    if (planId) {
      dispatch(maintenanceManagementActions.getMaintenancePlanRequest(planId));
    }
  }, [planId]);

  useEffect(() => {
    if ((readOnly || isEdit) && !isEmpty(maintenancePlan)) {
      setFormData((pre: any) => ({
        ...pre,
        ...maintenancePlan,
        maintenance_id: maintenancePlan.mt_id,
        onto_manage_id: maintenancePlan.onto_manage_id,
        maintenance_type: maintenancePlan.mt_type,
        maintenance_name: maintenancePlan.mt_name,
        machines: machineryManagementData
          .filter((machine: any) => maintenancePlan.machine_ids.includes(machine.machine_id))
          .map((machine: any) => ({
            ...machine,
            checklist: (maintenancePlan.mt_checklists || []).filter(
              (activity: any) => activity.machine_id === machine.machine_id
            ),
          })),
        frequency: maintenancePlan.frequency,
        recurs_on: {
          daily_value: maintenancePlan.recurrence && maintenancePlan.frequency === 'daily' && get(maintenancePlan, 'recurrence_days[0]', '') !== 'weekdays' ? 'custom_days' : 'every_weekday',
          monthly_value: maintenancePlan.day_of_month ? 'custom_days' : 'every_month',
          yearly_value: maintenancePlan.nth_week ? 'every_selected_month' : 'custom_month',
          recurs_every: maintenancePlan.frequency === 'daily' && get(maintenancePlan, 'recurrence_days[0]', '') === 'weekdays' ? null : maintenancePlan.recurrence,
          recurs_days:
            ['daily', 'monthly', 'yearly'].includes(maintenancePlan.frequency)
              ? maintenancePlan.recurrence_days[0]
              : maintenancePlan.recurrence_days,
          nth_week: maintenancePlan.nth_week,
          day_of_month: maintenancePlan.day_of_month,
          month: maintenancePlan.month,
        },
        start_date: dayjs(maintenancePlan.start_date),
        end_date: dayjs(maintenancePlan.end_date),
        is_no_end_date: !maintenancePlan.end_date,
        maintenance_time: dayjs.utc(maintenancePlan.mt_time, 'HH:mm:ss').local().format('hh:mm A'),
        reference_doc: maintenancePlan.documents ?? [],
        description: maintenancePlan.description,
        severity: maintenancePlan.priority ?? 3,
      }));
      dispatch(machineryManagementActions.getMachineryManagementDataRequest({ onto_manage_id: get(maintenancePlan, 'onto_manage_id', 0) }))
    }
  }, [readOnly, isEdit, maintenancePlan]);

  useEffect(() => {
    if ((readOnly || isEdit) && !isEmpty(maintenancePlan) && !isEmpty(machineryManagementData)) {
      setFormData((pre: any) => ({
        ...pre,
        machines: machineryManagementData
          .filter((machine: any) => maintenancePlan.machine_ids.includes(machine.machine_id))
          .map((machine: any) => ({
            ...machine,
            checklist: (maintenancePlan.mt_checklists || []).filter(
              (activity: any) => activity.machine_id === machine.machine_id
            ),
          })),
      }));
    }
  }, [machineryManagementData])

  useEffect(() => {
    if (!isEmpty(machineryManagementData) && !isEmpty(get(location, 'state.machines', []))) {
      setFormData((pre: any) => ({
        ...pre,
        machines: machineryManagementData
          .filter((machine: any) => get(location, 'state.machines', []).includes(machine.machine_id))
      }));
      let _machine: any = {};
      get(location, 'state.machines', []).forEach((item: any, idx: any) => {
        _machine = { ..._machine, ['machine_id' + (idx + 1)]: item }
      })
      dispatch(maintenanceManagementActions.checkMachineRequest({ ..._machine }))
    }
  }, [location, machineryManagementData])

  useEffect(() => {
    if (!isEmpty(checkMachinePlanData)) {
      setFormData({ ...formData, onto_manage_id: get(checkMachinePlanData, 'onto_manage_id', 0) });
    }
  }, [checkMachinePlanData])

  useEffect(() => {
    if (addMaintenancePlanSuccess || updateMaintenancePlanSuccess) {
      setPopupStatus({
        open: true,
        message: addMaintenancePlanSuccess
          ? `New ${formData.maintenance_name} has been successfully created`
          : `${formData.maintenance_name} has been successfully updated`,
      });
    }
  }, [addMaintenancePlanSuccess, updateMaintenancePlanSuccess]);

  useEffect(() => {
    if (resetOntology) {
      setResetOntology(false);
    }
  }, [resetOntology])

  const frequencyList: any = [
    {
      label: 'Daily',
      value: 'daily',
    },
    {
      label: 'Weekly',
      value: 'weekly',
    },
    {
      label: 'Monthly',
      value: 'monthly',
    },
    {
      label: 'Yearly',
      value: 'yearly',
    },
  ];

  const handleFormChange = (event: any) => {
    if (event.target.name === 'is_no_end_date') {
      if (formData.is_no_end_date) {
        setFormData({ ...formData, [event.target.name]: false });
      } else {
        setFormData({ ...formData, [event.target.name]: true });
      }
    } else {
      setFormData({ ...formData, [event.target.name]: event.target.value });
    }
  }

  const uploadFile = (e: any) => {
    let files = e.target.files;
    if (files.length) {
      const fileData = files[0];

      setFormData({
        ...formData,
        reference_doc: [
          ...(formData.reference_doc || []),
          {
            name: get(files, '[0].name', ''),
            file: fileData,
          },
        ],
      });
    }
  };

  const handleMachineList = (e: any, value: any) => {
    setFormData({ ...formData, machines: value })
  }

  const assignChecklist = (value: any, machineId: any) => {
    setFormData({
      ...formData, machines: formData.machines.map((machine: any) => {
        if (machine.machine_id === machineId) {
          return {
            ...machine,
            checklist: value
          }
        }
        return machine
      })
    });
  }

  const handleRecursChange = (item: any) => {
    setFormData({ ...formData, recurs_on: item })
  }

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const ajvSchema: any = cloneDeep(maintenanceSchema);
    if (formData.maintenance_type === 'preventive') {

      if (formData.frequency === 'daily') {
        ajvSchema.properties.recurs_on = cloneDeep(dailySchema);

        if (formData.recurs_on.daily_value === 'custom_days') {
          ajvSchema.properties.recurs_on.properties.recurs_every = cloneDeep(customDaysSchema);
          ajvSchema.properties.recurs_on.required.push('recurs_every');
        }
      }

      if (formData.frequency === 'weekly') {
        ajvSchema.properties.recurs_on = cloneDeep(weeklySchema);
      }

      if (formData.frequency === 'monthly') {
        ajvSchema.properties.recurs_on = cloneDeep(monthlySchema);
        if (formData.recurs_on.monthly_value === 'custom_days') {
          ajvSchema.properties.recurs_on = { ...ajvSchema.properties.recurs_on, ...cloneDeep(monthlySchemaCustomDays) };
        }

        if (formData.recurs_on.monthly_value === 'every_month') {
          ajvSchema.properties.recurs_on = {
            ...ajvSchema.properties.recurs_on,
            ...cloneDeep(monthlySchemaEveryMonth),
          };
        }
      }

      if (formData.frequency === 'yearly') {
        ajvSchema.properties.recurs_on = cloneDeep(yearlySchema);
        if (formData.recurs_on.yearly_value === 'custom_month') {
          ajvSchema.properties.recurs_on.properties = {
            ...cloneDeep(yearlySchema.properties),
            ...cloneDeep(yearlySchemaCustomMonth.properties),
          };
          ajvSchema.properties.recurs_on.required = [
            ...cloneDeep(yearlySchema.required),
            ...cloneDeep(yearlySchemaCustomMonth.required),
          ];
        }

        if (formData.recurs_on.yearly_value === 'every_selected_month') {
          ajvSchema.properties.recurs_on.properties = {
            ...cloneDeep(yearlySchema.properties),
            ...cloneDeep(yearlySchemaCustomSelected.properties),
          };
          ajvSchema.properties.recurs_on.required = [
            ...cloneDeep(yearlySchema.required),
            ...cloneDeep(yearlySchemaCustomSelected.required),
          ];
        }
      }
    }

    if (formData.maintenance_type === 'corrective') {
      ajvSchema.properties.severity = cloneDeep(severitySchema);
      ajvSchema.required.push('severity');
    }

    /**  convert time string to UTC time code starts */
    let _tempStartDate = new Date(dayjs(formData.start_date).format('MMMM DD, YYYY') +' '+formData.maintenance_time);
    let _tempDateISO = _tempStartDate.toISOString();
    const _mtTime = dayjs.utc(_tempDateISO).format('hh:mm A');
    /** convert time string to UTC time code ends */

    const validate = ajv.compile(ajvSchema);
    const params = {
      onto_manage_id: formData.onto_manage_id,
      mt_name: formData.maintenance_name,
      mt_type: formData.maintenance_type.toLowerCase(),
      machine_ids: formData.machines.map(({ machine_id }: { machine_id: number }) => machine_id),
      line_name: 'M1',
      priority: formData.severity,
      start_date: dayjs(formData.start_date).format('MMM-DD-YYYY'),
      end_date: formData.is_no_end_date ? null : dayjs(formData.end_date).format('MMM-DD-YYYY'),
      mt_time: _mtTime,
      frequency: formData.frequency,
      recurrence: get(formData, 'recurs_on.recurs_days', '') === 'weekdays' ? 1 : Number(formData.recurs_on.recurs_every),
      recurrence_days:
        formData.frequency === 'weekly'
          ? formData.recurs_on.recurs_days
          : formData.recurs_on.recurs_days
            ? Array.isArray(formData.recurs_on.recurs_days)
              ? formData.recurs_on.recurs_days
              : [formData.recurs_on.recurs_days]
            : [],
      day_of_month: Number(formData.recurs_on.day_of_month) || null,
      nth_week: Number(formData.recurs_on.nth_week) || null,
      month: Number(formData.recurs_on.month) || null,
      description: formData.description,
      mt_status: isEdit ? formData.mt_status : 'created',
      assigned_to: null,
      is_active: true,
      checklists: formData.machines.reduce((acc: any, machine: any) => {
        return [
          ...acc,
          ...(machine.checklist || []).map((list: any) => ({ ...list, machine_id: machine.machine_id })),
        ];
      }, []),
      documents: (formData.reference_doc || []).map((doc: any) => (typeof doc === 'string' ? doc : doc.name)),
    };

    // if (!params.onto_manage_id) {
    //   setAjvErrors({ instancePath: 'onto_manage_id' });
    //   return
    // }

    if (validate({ ...formData })) {
      //checklist validation
      // if (params.machine_ids.length) {
      //   const checkForChecklists = (formData.machines || []).filter((machine: any) => !get(machine, 'checklist', []).length);
      //   if (checkForChecklists.length) {
      //     setAjvErrors({ instancePath: 'checklist' });
      //     return;
      //   }
      // }

      const payload = new FormData();
      payload.append('maintenance', JSON.stringify(params));

      formData.reference_doc.filter((doc: any) => doc.file).forEach((doc: any) => {
        payload.append('maintenance_documents', doc.file);
      });

      if (isEdit) {
        payload.append('maintenance_id', formData.maintenance_id);
        dispatch(maintenanceManagementActions.updateMaintenancePlanRequest(payload));
      } else {
        dispatch(maintenanceManagementActions.addMaintenancePlanRequest(payload));
      }
      setAjvErrors({});
      return true;
    } else {
      if (validate.errors) {
        // console.log(validate.errors);
        setAjvErrors(validate.errors[0]);
      }
      return false;
    }
  }

  const onCloseChecklistModal = () => {
    setChecklistModal({ open: false, checklistId: null });
  }

  const onNavigateBack = () => {
    dispatch(maintenanceManagementActions.resetMaintenancePlanState());
    navigate('/maintenance-management/' + get(location, 'state.from', 'plan-list'), {
      state: {
        tab: get(location, 'state.tab', 'preventive'),
      },
    });
  };

  const onPopupBackClick = () => {
    onNavigateBack()
    setPopupStatus({ open: false, message: '' })
  };

  return (
    <>
      <Grid container>
        <Grid item lg={12}>
          <Card sx={{ ...Styles.card, width: 'auto', gap: '0px', padding: '0px', position: 'relative' }}>
            {(maintenancePlanLoading || addMaintenancePlanLoading || updateMaintenancePlanLoading) && (
              <Box
                style={{
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                  zIndex: 10,
                }}
              >
                <CircularProgress />
              </Box>
            )}
            <CardContent component='form' onSubmit={handleSubmit} sx={{ padding: '0' }}>
              <Grid container>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{
                    borderBottom: `1px solid ${theme.palette.customBorderColor.main}`,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: '24px',
                  }}
                >
                  {readOnly ? (
                    <Button
                      variant='contained'
                      type='button'
                      sx={{ marginLeft: '16px' }}
                      onClick={() => {
                        navigate(`/maintenance-management/plan-list/edit/${planId}`, {
                          state: {
                            tab: get(location, 'state.tab', 'preventive'),
                          },
                        });
                      }}
                    >
                      <CreateIcon />
                      Edit
                    </Button>
                  ) : isEdit ? (
                    <>
                      <Button
                        variant='outlined'
                        onClick={() => {
                          onNavigateBack();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button variant='contained' type='submit' sx={{ marginLeft: '16px' }}>
                        <SaveIcon />
                        Save
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant='outlined'
                        onClick={() => {
                          onNavigateBack();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button variant='contained' type='submit' sx={{ marginLeft: '16px' }}>
                        <SaveIcon />
                        Save
                      </Button>
                    </>
                  )}
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{
                    backgroundColor: themeMode.isLightBG
                      ? lighten(theme.palette.background.default, 0.2)
                      : lighten(theme.palette.background.default, 0.08),
                  }}
                >
                  {!maintenancePlanLoading && (
                    <OntologySelector
                      isOntoManagesLoading={isOntoManagesLoading}
                      padding='14px 32px 14px 32px'
                      ontoManageId={get(formData, 'onto_manage_id', get(maintenancePlan, 'onto_manage_id', 0))}
                      ontologyData={ontologyData}
                      showLayout={true}
                      onOntoFilterChange={(data: any) => {
                        setFormData({ ...formData, onto_manage_id: data.onto_manage_id, machines: [] });
                        dispatch(
                          machineryManagementActions.getMachineryManagementDataRequest({
                            onto_manage_id: data.onto_manage_id,
                          })
                        );
                      }}
                      isError={ajvErrors.instancePath && ajvErrors.instancePath.includes('onto_manage_id')}
                      label={
                        <Typography
                          sx={{
                            width: 'auto',
                            minWidth: '92px',
                            fontSize: '1rem',
                            fontWeight: 400,
                            whiteSpace: 'nowrap',
                            marginRight: '24px',
                          }}
                        >
                          Select Ontology
                        </Typography>
                      }
                      disabled={readOnly || !isEmpty(get(location, 'state.machines', []))}
                      reset={resetOntology}
                    />
                  )}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container sx={{ paddingTop: '24px', paddingBottom: '24px' }}>
                    <Grid item xs={12} sm={12} md={6} lg={4} sx={customStyles.inputContainer}>
                      <Grid container display={'flex'} gap={3}>
                        <Grid item xs={12} sm={12} md={12} sx={{}}>
                          <Typography variant='subtitle1'>
                            Maintenance Type <RequiredFieldStar />
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <RadioGroup
                            row
                            aria-labelledby='demo-row-radio-buttons-group-label'
                            name='row-radio-buttons-group'
                            sx={{ marginTop: '8px' }}
                          >
                            <FormControlLabel
                              disabled={readOnly}
                              sx={customStyles.radiolabel}
                              value='preventive'
                              control={<RadioComponent />}
                              name='maintenance_type'
                              label='Preventive'
                              checked={formData.maintenance_type === 'preventive'}
                              onChange={() => {
                                setFormData({
                                  ...formData,
                                  maintenance_type: 'preventive',
                                  recurs_on: {
                                    daily_value: '',
                                    recurs_every: '',
                                    recurs_days: [],
                                    nth_week: null,
                                    day_of_month: null,
                                    month: null,
                                    monthly_value: '',
                                    yearly_value: '',
                                  },
                                  start_date: dayjs(),
                                  end_date: dayjs(),
                                  is_no_end_date: false,
                                });
                              }}
                            />
                            <FormControlLabel
                              disabled={readOnly}
                              sx={customStyles.radiolabel}
                              value='corrective'
                              control={<RadioComponent />}
                              name='maintenance_type'
                              label='Corrective'
                              checked={formData.maintenance_type === 'corrective'}
                              onChange={() => {
                                setFormData({
                                  ...formData,
                                  maintenance_type: 'corrective',
                                  recurs_on: {
                                    daily_value: '',
                                    recurs_every: '',
                                    recurs_days: [],
                                    nth_week: null,
                                    day_of_month: null,
                                    month: null,
                                    monthly_value: '',
                                    yearly_value: '',
                                  },
                                  start_date: dayjs(),
                                  end_date: dayjs(),
                                  is_no_end_date: false,
                                });
                              }}
                            />
                          </RadioGroup>
                        </Grid>
                      </Grid>
                      <Grid container display={'flex'}>
                        <Grid item xs={12} sm={12} md={12}>
                          <Typography variant='subtitle1' sx={{ paddingBottom: '0px' }}>
                            Maintenance Name <RequiredFieldStar />
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} sx={{}}>
                          <TextField
                            sx={{ marginTop: '8px', mb: 0 }}
                            margin='normal'
                            fullWidth
                            id={'maintenance_name'}
                            onChange={handleFormChange}
                            name={'maintenance_name'}
                            autoComplete={'maintenance_name'}
                            autoFocus
                            variant='outlined'
                            value={formData.maintenance_name}
                            size='small'
                            disabled={readOnly}
                            placeholder='Enter Name'
                            helperText={
                              ajvErrors.instancePath &&
                              ajvErrors.instancePath.includes('maintenance_name') &&
                              ajvErrors.message
                            }
                            error={ajvErrors.instancePath && ajvErrors.instancePath.includes('maintenance_name')}
                          />
                        </Grid>
                      </Grid>
                      <Grid container display={'flex'}>
                        <Grid item xs={12} sm={12} md={12}>
                          <Typography variant='subtitle1'>
                            Machine Name <RequiredFieldStar />
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <Autocomplete
                            disabled={readOnly}
                            multiple
                            value={formData.machines ?? []}
                            options={machineryManagementData}
                            onChange={handleMachineList}
                            isOptionEqualToValue={(option, value) => option.machine_id === value.machine_id}
                            disableCloseOnSelect
                            disableClearable
                            getOptionLabel={(option: any) => option.machine_name}
                            popupIcon={<DownwardIcon />}
                            ChipProps={{
                              sx: {
                                '&.Mui-disabled': {
                                  opacity: 1
                                },
                              },
                              deleteIcon: <CloseIcon style={{ color: readOnly ? '' : theme.palette.primary.main }} />,
                            }}
                            renderOption={(props, option, { selected }) => {
                              const { key, ...optionProps } = props;
                              return (
                                <li key={key} {...optionProps}>
                                  <CheckboxComponent
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CheckBoxIcon />}
                                    style={{ marginRight: '8px' }}
                                    checked={selected}
                                  />
                                  {option.machine_name}
                                </li>
                              );
                            }}
                            sx={{
                              marginTop: '8px',
                              '& .MuiAutocomplete-inputRoot': {
                                flexWrap: 'nowrap',
                                display: '-webkit-inline-box',
                                height: 'auto !important',
                              },
                              '& .MuiAutocomplete-tag': {
                                color: palette.info.dark,
                                '& .MuiSvgIcon-root': {
                                  color: palette.info.dark,
                                  opacity: '0.7',
                                },
                              },

                              ...(!readOnly && {
                                '& .MuiFormControl-root .MuiInputBase-root .MuiChip-root': {
                                  backgroundColor: lighten(theme.palette.primary.main, 0.9),
                                  border: `2px solid ${theme.palette.primary.main}`,
                                  color: theme.palette.primary.main,
                                },
                              }),
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={formData.machines.length ? '' : 'Select Machine'}
                                sx={{
                                  '.MuiOutlinedInput-root': {
                                    padding: '2px 8px !important',
                                    // height: '24px',
                                  },
                                  '& .MuiFormControl-root .MuiInputBase-root .MuiButtonBase-root': {
                                    padding: '0px 8px !important',
                                  },
                                }}
                                error={ajvErrors.instancePath && ajvErrors.instancePath.includes('machines')}
                                helperText={
                                  ajvErrors.instancePath &&
                                  ajvErrors.instancePath.includes('machines') &&
                                  ajvErrors.message
                                }
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} sx={customStyles.inputContainer}>
                      {formData.maintenance_type === 'corrective' ? (
                        <Fragment>
                          <Grid container display={'flex'}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              sx={{
                                marginBottom: '8px',
                              }}
                            >
                              <Typography variant='subtitle1'>
                                Priority <RequiredFieldStar />
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                              <SelectComponent
                                disabled={readOnly}
                                value={formData.severity}
                                options={severityList}
                                onChange={(event: any) => {
                                  setFormData({
                                    ...formData,
                                    [event.target.name]: event.target.value,
                                    recurs_on: {
                                      daily_value: '',
                                      recurs_every: '',
                                      recurs_days: [],
                                      nth_week: null,
                                      day_of_month: null,
                                      month: null,
                                      monthly_value: '',
                                      yearly_value: '',
                                    },
                                  });
                                }}
                                name={'severity'}
                                error={ajvErrors.instancePath && ajvErrors.instancePath.includes('severity')}
                                helperText={
                                  ajvErrors.instancePath &&
                                  ajvErrors.instancePath.includes('severity') &&
                                  'Please select severity'
                                }
                              />
                            </Grid>
                          </Grid>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <Grid container display={'flex'}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              sx={{
                                marginBottom: '8px',
                                mt: tabView ? '24px' : '',
                              }}
                            >
                              <Typography variant='subtitle1'>
                                Frequency <RequiredFieldStar />
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                              <SelectComponent
                                disabled={readOnly}
                                value={formData.frequency}
                                options={frequencyList}
                                onChange={(event: any) => {
                                  setFormData({
                                    ...formData,
                                    [event.target.name]: event.target.value,
                                    recurs_on: {
                                      daily_value: '',
                                      recurs_every: '',
                                      recurs_days: [],
                                      nth_week: null,
                                      day_of_month: null,
                                      month: null,
                                      monthly_value: '',
                                      yearly_value: '',
                                    },
                                  });
                                  setAjvErrors({});
                                }}
                                name='frequency'
                                helperText=' Please select frequency'
                              />
                            </Grid>
                          </Grid>
                          <Grid container display={'flex'}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              sx={{
                                marginBottom: '6px',
                              }}
                            >
                              <Typography variant='subtitle1'>
                                Recurs <RequiredFieldStar />
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              sx={{
                                marginBottom: '6px',
                              }}
                            >
                              {formData.frequency === 'daily' && (
                                <DailyComponent
                                  disabled={readOnly}
                                  data={{
                                    recurs_every: formData.recurs_on.recurs_every || '',
                                    recurs_days: formData.recurs_on.recurs_days || [],
                                    daily_value: formData.recurs_on.daily_value || '',
                                  }}
                                  ajvErrors={ajvErrors}
                                  onChangeValues={(key: string, value: any) => {
                                    if (key === 'daily_value') {
                                      setFormData({
                                        ...formData,
                                        recurs_on: {
                                          ...formData.recurs_on,
                                          daily_value: value,
                                          recurs_days: value === 'custom_days' ? [] : 'weekdays',
                                          recurs_every: value ? Number(value) : value,
                                        },
                                      });
                                      setAjvErrors({});
                                    }
                                    if (key === 'recurs_every') {
                                      if (!isNaN(value)) {
                                        setFormData({
                                          ...formData,
                                          recurs_on: {
                                            ...formData.recurs_on,
                                            recurs_every: value ? Number(value) : value,
                                          },
                                        });
                                      }
                                    }
                                  }}
                                />
                              )}
                              {formData.frequency === 'weekly' && (
                                <WeeklyComponent
                                  disabled={readOnly}
                                  data={{
                                    recurs_every: formData.recurs_on.recurs_every || '',
                                    recurs_days: formData.recurs_on.recurs_days || [],
                                  }}
                                  ajvErrors={ajvErrors}
                                  onChangeValues={(key: string, value: any) => {
                                    if (key === 'recurs_every') {
                                      if (!isNaN(value)) {
                                        setFormData({
                                          ...formData,
                                          recurs_on: {
                                            ...formData.recurs_on,
                                            recurs_every: value ? Number(value) : value,
                                          },
                                        });
                                      }
                                    }
                                    if (key === 'recurs_days') {
                                      const recursDays = get(formData, 'recurs_on.recurs_days', []);
                                      setFormData({
                                        ...formData,
                                        recurs_on: {
                                          ...formData.recurs_on,
                                          recurs_days: recursDays.includes(value)
                                            ? recursDays.filter((day: string) => day !== value)
                                            : [...recursDays, value],
                                        },
                                      });
                                    }
                                  }}
                                />
                              )}
                              {formData.frequency === 'monthly' && (
                                <MonthlyComponent
                                  disabled={readOnly}
                                  handleRecursChange={handleRecursChange}
                                  data={{
                                    monthly_value: formData.recurs_on.monthly_value || '',
                                    day_of_month: formData.recurs_on.day_of_month || '',
                                    recurs_every: formData.recurs_on.recurs_every || '',
                                    nth_week: formData.recurs_on.nth_week,
                                    recurs_days: formData.recurs_on.recurs_days,
                                  }}
                                  ajvErrors={ajvErrors}
                                  onChangeValues={(key: string, value: any) => {
                                    // console.log({ key, value });
                                    if (['day_of_month', 'recurs_every'].includes(key)) {
                                      if (!isNaN(value)) {
                                        setFormData({
                                          ...formData,
                                          recurs_on: { ...formData.recurs_on, [key]: value ? Number(value) : value },
                                        });
                                      }
                                    } else if (key === 'monthly_value') {
                                      setFormData({
                                        ...formData,
                                        recurs_on: {
                                          ...formData.recurs_on,
                                          [key]: value,
                                          recurs_days: [],
                                          recurs_every: '',
                                          day_of_month: '',
                                          nth_week: null,
                                        },
                                      });
                                      setAjvErrors({});
                                    } else {
                                      setFormData({
                                        ...formData,
                                        recurs_on: { ...formData.recurs_on, [key]: value },
                                      });
                                    }
                                  }}
                                />
                              )}
                              {formData.frequency === 'yearly' && (
                                <YearlyComponent
                                  disabled={readOnly}
                                  handleRecursChange={handleRecursChange}
                                  data={{
                                    recurs_every: formData.recurs_on.recurs_every,
                                    yearly_value: formData.recurs_on.yearly_value,
                                    month: formData.recurs_on.month,
                                    day_of_month: formData.recurs_on.day_of_month,
                                    nth_week: formData.recurs_on.nth_week,
                                    recurs_days: formData.recurs_on.recurs_days,
                                  }}
                                  ajvErrors={ajvErrors}
                                  onChangeValues={(key: string, value: any) => {
                                    if (key === 'day_of_month' || key === 'recurs_every') {
                                      if (!isNaN(value)) {
                                        setFormData({
                                          ...formData,
                                          recurs_on: {
                                            ...formData.recurs_on,
                                            [key]: value ? Number(value) : '',
                                          },
                                        });
                                      }
                                    } else {
                                      if (key === 'yearly_value') {
                                        setFormData({
                                          ...formData,
                                          recurs_on: {
                                            ...formData.recurs_on,
                                            daily_value: '',
                                            recurs_days: [],
                                            nth_week: null,
                                            day_of_month: '',
                                            month: null,
                                            monthly_value: '',
                                            [key]: value,
                                          },
                                        });
                                        setAjvErrors({});
                                      } else {
                                        setFormData({
                                          ...formData,
                                          recurs_on: { ...formData.recurs_on, [key]: value },
                                        });
                                      }
                                    }
                                  }}
                                />
                              )}
                              {((ajvErrors.instancePath && ajvErrors.instancePath.includes('recurs_on')) ||
                                (ajvErrors.instancePath && ajvErrors.instancePath.includes('every_day_on'))) && (
                                  <Typography
                                    variant='body2'
                                    color='error'
                                    sx={{ fontWeight: '400', fontSize: '1rem', lineHeight: '22px', mt: 2 }}
                                  >
                                    {ajvErrors.message}
                                  </Typography>
                                )}
                            </Grid>
                          </Grid>{' '}
                        </Fragment>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={4}
                      sx={{ ...customStyles.inputContainer, borderRight: 0, mt: mdScreenView ? '24px' : '' }}
                    >
                      <Grid container sx={{ gap: '10px' }}>
                        <Grid item xl={5.85} lg={5.7} md={5.5} sm={12} xs={12}>
                          <Grid container display={'flex'}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              sx={{
                                marginBottom: '8px',
                              }}
                            >
                              <Typography variant='subtitle1'>
                                Start Date <RequiredFieldStar />
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  disabled={readOnly}
                                  minDate={dayjs(get(maintenancePlan, 'start_date', new Date()))}
                                  defaultValue={dayjs(get(maintenancePlan, 'start_date', new Date()))}
                                  name='start_date'
                                  onChange={(newValue) => {
                                    setFormData({ ...formData, start_date: newValue });
                                  }}
                                  value={formData.start_date}
                                />
                              </LocalizationProvider>
                            </Grid>
                          </Grid>
                        </Grid>
                        {formData.maintenance_type === 'preventive' && (
                          <Grid item xl={5.85} lg={5.7} md={5.5} sm={12} xs={12}>
                            <Grid container display={'flex'}>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                sx={{
                                  marginBottom: '8px',
                                }}
                              >
                                <Typography variant='subtitle1'>
                                  End Date <RequiredFieldStar />
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <DatePicker
                                    disabled={formData.is_no_end_date || readOnly}
                                    minDate={dayjs(get(formData, 'start_date', new Date()))}
                                    name='end_date'
                                    onChange={(newValue) => {
                                      setFormData({ ...formData, end_date: newValue });
                                    }}
                                    value={formData.end_date}
                                  />
                                </LocalizationProvider>
                                <FormControlLabel
                                  disabled={readOnly}
                                  sx={{ ...customStyles.radiolabel, ml: 0 }}
                                  value='No End Date'
                                  style={{ whiteSpace: 'nowrap' }}
                                  control={
                                    <CheckboxComponent
                                      icon={<CheckBoxOutlineBlankIcon />}
                                      checkedIcon={<CheckBoxIcon />}
                                      style={{ paddingLeft: '2px' }}
                                      name='is_no_end_date'
                                      handleCheckboxChange={(e: any) => {
                                        setFormData({ ...formData, is_no_end_date: e.target.checked });
                                      }}
                                      checked={formData.is_no_end_date}
                                    />
                                  }
                                  label='No End Date'
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                      <Grid container display={'flex'}>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          sx={{
                            marginBottom: '8px',
                          }}
                        >
                          <Typography variant='subtitle1'>
                            Maintenance Time <RequiredFieldStar />
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} xl={5.85} lg={5.7} md={5.5}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <TimePickerComponent
                              value={formData.maintenance_time}
                              onSave={(newValue: string) => {
                                setFormData({ ...formData, maintenance_time: newValue });
                              }}
                              disabled={readOnly}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={{
                    paddingTop: '24px',
                    paddingBottom: '24px',
                    borderTop: `1px solid ${theme.palette.customBorderColor.main}`,
                  }}
                >
                  <Grid item xs={12} sm={6} md={4} lg={4} sx={customStyles.inputContainer}>
                    <Grid container display={'flex'}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        sx={{
                          marginBottom: '8px',
                        }}
                      >
                        <Typography sx={Styles.inputLabel}>Upload Reference Document</Typography>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Button
                            disabled={readOnly}
                            sx={{
                              width: '100%',
                              display: 'flex',
                              padding: '0px 0px 0px 16px',
                              justifyContent: 'space-between',
                              backgroundColor: readOnly ? theme.palette.custom.contrastText : `${palette.primary.contrastText} !important`,
                              borderColor: `${theme.palette.customBorderColor.main}`,
                              textTransform: 'lowercase',
                              ':hover': {
                                backgroundColor: `${palette.primary.contrastText} !important`,
                              },
                              '&.Mui-disabled': {
                                borderColor: theme.palette.customBorderColor.dark
                              }
                            }}
                            variant='outlined'
                            component='label'
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                fontStyle: 'italic',
                                color: '#c8c8ca',
                                opacity: '0.7',
                                flexDirection: 'row',
                                textTransform: 'capitalize'
                              }}
                            >
                              Select File
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                textTransform: 'uppercase',
                                padding: '10px 16px',
                                border: `1px solid ${
                                  readOnly ? theme.palette.customBorderColor.dark : theme.palette.customBorderColor.main
                                  }`,
                                borderRadius: '8px',
                                height: '100%',
                                backgroundColor: readOnly ? '#cbcbcb' : ''
                              }}
                            >
                              Browse
                            </div>
                            <VisuallyHiddenInput
                              disabled={readOnly}
                              type='file'
                              onChange={uploadFile}
                              onClick={(event: any) => {
                                event.target.value = null;
                              }}
                            />
                          </Button>
                        </Box>
                      </Grid>
                      <Box>
                        {formData.reference_doc.map((document: any, idx: number) => {
                          const docName = typeof document === 'string' ? document : get(document, 'name', 'file');
                          let doc = docName;
                          let isLink = false;
                          if (doc.includes('http')) {
                            const splittedDoc = doc.split('/');
                            doc = splittedDoc[splittedDoc.length - 1];
                            isLink = true;
                          }

                          return (
                            <Box key={docName + idx} sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                              {isLink ? (
                                <Typography
                                  fontWeight={400}
                                  fontSize={16}
                                  color='primary'
                                  sx={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    dispatch(
                                      maintenanceManagementActions.downloadDocumentRequest({
                                        section: 'maintenance',
                                        document,
                                        id: maintenancePlan.mt_id,
                                      })
                                    );
                                  }}
                                >
                                  {doc}
                                </Typography>
                              ) : (
                                <Typography fontWeight={400} fontSize={16} color='primary'>
                                  {doc}
                                </Typography>
                              )}
                              {!readOnly && (
                                <IconButton
                                  sx={{ p: '4px' }}
                                  onClick={() => {
                                    // Remove the document by index for reliability
                                    const updatedDocs = formData.reference_doc.filter((_: any, i: number) => i !== idx);
                                    setFormData({ ...formData, reference_doc: updatedDocs });
                                  }}
                                >
                                  <CloseIcon style={{ color: theme.palette.custom.light }} />
                                </IconButton>
                              )}
                            </Box>
                          );
                        })}
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} sx={{ ...customStyles.inputContainer, border: 'none' }}>
                    <Grid container display={'flex'}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        sx={{
                          marginBottom: '8px',
                        }}
                      >
                        <Typography sx={Styles.inputLabel}>Description</Typography>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <TextField
                          disabled={readOnly}
                          id='outlined-multiline-static'
                          sx={{
                            '&.MuiFormControl-root': { width: '100%' },
                            '.MuiOutlinedInput-root': { height: 'auto !important', width: '100%', minWidth: '300px' },
                          }}
                          multiline
                          rows={4}
                          name='description'
                          value={formData.description}
                          onChange={handleFormChange}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={{
                    padding: '16px 32px',
                    borderTop: `1px solid ${theme.palette.customBorderColor.main}`,
                    borderBottom: `1px solid ${theme.palette.customBorderColor.main}`,
                  }}
                >
                  <Grid item xs={6}>
                    <Typography sx={{ fontSize: '16px', fontWeight: 600 }}>Maintenance Activity</Typography>
                  </Grid>
                </Grid>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                  <Grid
                    container
                    sx={{
                      padding: '18px 0px 18px 32px',
                      display: 'flex',
                      alignItems: 'center',
                      flexWrap: 'nowrap',
                      borderBottom: `1px solid ${theme.palette.customBorderColor.main}`,
                      ml: 0,
                      width: '100%',
                    }}
                    columnSpacing={4}
                  >
                    {[
                      { label: 'SELECTED MACHINE', minWidth: '200px' },
                      { label: 'SELECT ACTIVITY CHECKLIST', minWidth: '300px' },
                      { label: 'SELECTED ACTIVITY CHECKLIST', minWidth: '300px' },
                    ].map(({ label, minWidth }) => (
                      <Grid
                        key={label}
                        xs={4}
                        md={4}
                        lg={4}
                        xl={4}
                        sx={{ display: 'flex', alignItems: 'center', minWidth: minWidth, whiteSpace: 'nowrap' }}
                      >
                        <Typography variant='subtitle2'>{label}</Typography>
                      </Grid>
                    ))}
                  </Grid>

                  {/* <Grid
                  container
                  sx={{
                    display:'flex',
                    alignItems:'center',
                    padding: '14px 0px 14px 32px',
                    borderTop: `1px solid ${theme.palette.customBorderColor.main}`,
                    borderBottom: `1px solid ${theme.palette.customBorderColor.main}`,
                    flexWrap:'nowrap',
                    flexDirection:'column'
                  }}
                  columnSpacing={4}
                > */}
                  <Box sx={{ display: 'flex', flexWrap: 'nowrap', width: '100%', flexDirection: 'column' }}>
                    {formData.machines.length ? (
                      formData.machines.map((item: any, idx: number) => (
                        <Grid
                          container
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '14px 0px 14px 32px',
                            borderTop: `1px solid ${theme.palette.customBorderColor.main}`,
                            borderBottom: `1px solid ${theme.palette.customBorderColor.main}`,
                            flexWrap: 'nowrap',
                            backgroundColor: idx % 2 === 0 ? '' : lighten(theme.palette.background.default, 0.05),
                          }}
                          columnSpacing={4}
                        >
                          <Grid
                            item
                            xs={4}
                            sm={4}
                            md={4}
                            lg={4}
                            sx={{ padding: '0px 10px 0px 0px', minWidth: '200px' }}
                          >
                            <TextField
                              sx={{ marginTop: '0px' }}
                              margin='normal'
                              fullWidth
                              id={'selected_machine'}
                              onChange={() => {}}
                              name={'selected_machine'}
                              variant='outlined'
                              value={item.machine_name}
                              size='small'
                              aria-readonly
                              disabled
                            // helperText={name === 'cidr_to_scan' ? <div style={{ display: 'flex', flexDirection: 'column' }}><small style={{ color: 'rgb(100, 117, 159)', fontSize: '0.75rem' }}>IP range format e.g. 192.168.10.0/24 or 192.168.1.0-255 or 192.168.1.20-30  </small>{ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && <div style={{ lineHeight: '1' }}>{ajvErrors.message.toLowerCase()}</div>} </div> : ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && ajvErrors.message.toLowerCase()}
                            // error={ajvErrors.instancePath && ajvErrors.instancePath.includes(name)}
                            />
                          </Grid>
                          {/* formdata.machines[item.id][checklist] */}
                          <Grid
                            item
                            xs={4}
                            sm={4}
                            md={4}
                            lg={4}
                            sx={{ padding: '0px 10px 0px 0px', minWidth: '300px' }}
                          >
                            <Autocomplete
                              disabled={readOnly}
                              multiple
                              value={item.checklist ?? []}
                              options={activities}
                              onChange={(event: any, value: any) => {
                                assignChecklist(value, item.machine_id);
                              }}
                              getOptionLabel={(option) => option.checklist_name}
                              isOptionEqualToValue={(option, value) => option.checklist_id === value.checklist_id}
                              popupIcon={<DownwardIcon />}
                              renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                  <li key={key} {...optionProps}>
                                    <CheckboxComponent
                                      icon={<CheckBoxOutlineBlankIcon />}
                                      checkedIcon={<CheckBoxIcon />}
                                      style={{ marginRight: '8px' }}
                                      checked={selected}
                                    />
                                    {option.checklist_name}
                                  </li>
                                );
                              }}
                              sx={{
                                '& .MuiAutocomplete-inputRoot': {
                                  flexWrap: 'nowrap',
                                },
                                '& .MuiAutocomplete-tag': {
                                  color: palette.info.dark,
                                  '& .MuiSvgIcon-root': {
                                    color: palette.info.dark,
                                    opacity: '0.7',
                                  },
                                },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder={'Select Activity'}
                                  sx={{
                                    '.MuiOutlinedInput-root': {},
                                    '& ::placeholder': {
                                      fontStyle: 'italic',
                                      opacity: 1,
                                      color: theme.palette.text.secondary
                                    }
                                  }}
                                  error={
                                    ajvErrors.instancePath &&
                                    ajvErrors.instancePath.includes(`checklist`) &&
                                    !(item.checklist || []).length
                                  }
                                />
                              )}
                              renderTags={() => null}
                            />
                          </Grid>
                          <Grid item xs={4} sm={4} md={4} lg={4} sx={{ minWidth: '200px' }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                              {(item.checklist || []).map((activity: any) => (
                                <Box
                                  key={activity.checklist_id}
                                  sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                >
                                  <Typography
                                    fontWeight={400}
                                    fontSize={16}
                                    color='primary'
                                    onClick={() =>
                                      setChecklistModal({ open: true, checklistId: activity.checklist_id })
                                    }
                                  >
                                    {activity.checklist_name}
                                  </Typography>
                                  {!readOnly && (
                                    <IconButton
                                      sx={{ p: '4px', ml: 1 }}
                                      onClick={() => {
                                        const updatedChecklist = item.checklist.filter(
                                          (act: any) => act.checklist_id !== activity.checklist_id
                                        );
                                        assignChecklist(updatedChecklist, item.machine_id);
                                      }}
                                    >
                                      <CloseIcon style={{ width: '24px', height: '24px' }} />
                                    </IconButton>
                                  )}
                                </Box>
                              ))}
                            </Box>
                          </Grid>
                        </Grid>
                      ))
                    ) : (
                      <Fragment>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ padding: '24px 10px 0px 0px' }}>
                          <Typography fontWeight={400} fontSize={16} sx={{ textAlign: 'center' }}>
                            No Machines to Add Checklists
                          </Typography>
                        </Grid>
                      </Fragment>
                    )}
                  </Box>
                  {/* </Grid> */}
                </Box>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        {/*  */}
      </Grid>
      <Modal
        open={checklistModal.open}
        title='VIEW ACTIVITY CHECKLIST'
        customStyles={{ width: '1200px', maxWidth: '1200px' }}
        handleClose={onCloseChecklistModal}
      >
        <Box sx={{ width: '100%', overflow: 'hidden' }}>
          <Box sx={{ height: '88%', overflow: 'auto' }}>
            <Box bgcolor={palette.primary.contrastText}>
              <AddEditActivity viewFromModal activityIdFromModal={checklistModal.checklistId} />
            </Box>
          </Box>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Button variant='outlined' sx={{ mr: 3, width: '100px', height: '42px' }} onClick={onCloseChecklistModal}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
      <PopUp
        title='Success'
        open={popupStatus.open}
        icon={<SuccessIcon style={{ color: palette.success.dark }} />}
        message={popupStatus.message}
        confirmation
        confirmLabel='OK'
        onConfirm={onPopupBackClick}
        onClose={onPopupBackClick}
      />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  ontoManages: state.ontologyMaster.OntoManages,
  isOntoManagesLoading: state.ontologyMaster.isOntoManagesLoading,
  ontologyData: state.ontologyMaster.ontologyData,
  ontologies: state.ontologyMaster.ontologyMgmntData,
  machineryManagementData: state.machineryManagement.machineryManagementData,
  activityListLoading: state.maintenanceManagement.isActivityListLoading,
  activities: state.maintenanceManagement.activityListData,
  addMaintenancePlanLoading: state.maintenanceManagement.addMaintenancePlanLoading,
  addMaintenancePlanSuccess: state.maintenanceManagement.addMaintenancePlanSuccess,
  maintenancePlanLoading: state.maintenanceManagement.singleMaintenancePlanLoading,
  maintenancePlan: state.maintenanceManagement.singleMaintenancePlan,
  updateMaintenancePlanLoading: state.maintenanceManagement.updateMaintenancePlanLoading,
  updateMaintenancePlanSuccess: state.maintenanceManagement.updateMaintenancePlanSuccess,
  checkMachineRequest: state.maintenanceManagement.checkMachineRequest,
  checkMachinePlanData: state.maintenanceManagement.checkMachinePlanData,
});

export default connect(mapStateToProps)(CreateMaintenance);
